import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    documentsPackageDownload: true,
};
